import { render, staticRenderFns } from "./Paywall.vue?vue&type=template&id=7ab37c0e&"
import script from "./Paywall.vue?vue&type=script&lang=ts&"
export * from "./Paywall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports